module.exports = __webpack_public_path__ + "img/close.be0f8270.svg";